import { render } from "./BaseTableProjectManagementAnswers.vue?vue&type=template&id=46a97a95&scoped=true"
import script from "./BaseTableProjectManagementAnswers.vue?vue&type=script&lang=js"
export * from "./BaseTableProjectManagementAnswers.vue?vue&type=script&lang=js"

import "./BaseTableProjectManagementAnswers.vue?vue&type=style&index=0&id=46a97a95&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a97a95"]])

export default __exports__